<template>
  <div class="dialog-wrapper">
    <div class="header">
      <i
        v-if="canCancel"
        class="material-icons close"
        role="button"
        tabindex="0"
        @click="$emit('cancel')"
        @keydown.enter="$emit('cancel')"
        @keydown.space="$emit('cancel')"
      >
        {{ $t('@@translate@@ close') }}
      </i>
      <div class="title"><slot name="header" /></div>
    </div>
    <div class="body">
      <slot />
    </div>
    <div class="footer"><slot name="footer" /></div>
  </div>
</template>

<script>
export default {
  name: 'dialog-wrapper',
  props: {
    canCancel: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.dialog-wrapper {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(150px);
  border-radius: 20px;
  min-width: 360px;
}

.header {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 16px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 44px;
  box-sizing: border-box;
  text-transform: uppercase;
}

.close {
  margin-right: 20px;
  cursor: pointer;
}

.body {
  padding: 15px;
  box-sizing: border-box;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer > * {
  margin: 0 5px;
}

.title {
  flex: 1;
}
</style>
